<template>
  <base-query class="thirdlogs-query">
    <el-form
      slot="searchBox"
      ref="ruleForm"
      size="mini"
      label-position="right"
      :model="ruleForm"
      label-width="100px"
    >
      <div class="contentLeft">
        <el-row>
          <el-col style="width: 22%">
            <el-form-item label="数据源">
              <el-select
                v-model="ruleForm.dataSource"
                clearable
                style="width: 100%"
                placeholder="请选择"
                :loading="optionloading"
                @focus="loaddatasource0"
              >
                <el-option
                  v-for="item in datasources"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col style="width: 25%">
            <el-form-item label="路径">
              <el-select
                v-model="ruleForm.path"
                clearable
                style="width: 100%"
                placeholder="请选择"
                :disabled="!ruleForm.dataSource"
                filterable
                :loading="optionloading"
                @focus="loadpath"
              >
                <el-option
                  v-for="item in paths"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col style="width: 22%">
            <el-form-item label="查询时间">
              <el-date-picker
                v-model="ruleForm.btm"
                type="datetime"
                style="width: 100%"
                placeholder="开始日期"
              />
            </el-form-item>
          </el-col>
          <el-col style="width: 22%">
            <el-form-item label="——">
              <el-date-picker
                v-model="ruleForm.etm"
                style="width: 100%"
                type="datetime"
                placeholder="结束日期"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="width: 22%">
            <el-form-item label="用户名">
              <el-input
                v-model="ruleForm.caller"
                style="width: 100%"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col style="width: 25%">
            <el-form-item label="请求内容">
              <el-input
                v-model="ruleForm.requestBody"
                style="width: 100%"
                clearable
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col style="width: 22%">
            <el-form-item label="响应内容">
              <el-input
                v-model="ruleForm.responseBody"
                clearable
                style="width: 100%"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col style="width: 22%">
            <el-form-item label="响应时间">
              <el-input
                v-model="ruleForm.elapsedTime"
                clearable
                style="width: 100%"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="width: 22%">
            <el-form-item label="来自路径">
              <el-input
                v-model="ruleForm.fromPath"
                style="width: 100%"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col style="width: 25%">
            <el-form-item label="类名">
              <el-input
                v-model="ruleForm.className"
                style="width: 100%"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col style="width: 22%">
            <el-form-item label="每页数量">
              <el-select
                v-model="ruleForm.size"
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option value="50" label="50" />
                <el-option value="100" label="100" />
                <el-option value="150" label="150" />
                <el-option value="200" label="200" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="contenRight">
        <el-button
          size="small"
          class="serachBtn"
          :loading="isloading"
          @click="onsearch"
        >
          搜索
        </el-button>
      </div>
      <div style="clear: both"></div>
    </el-form>

    <el-table v-loading="isloading" :data="data" height="550px" row-key="id">
      <el-table-column
        prop="dataSource"
        label="数据源"
        show-overflow-tooltip
        align="left"
        width="100"
      />

      <el-table-column
        prop="method"
        label="请求方法"
        show-overflow-tooltip
        align="left"
        width="100"
      />

      <el-table-column prop="path" label="路径" align="left">
        <el-tooltip
          slot-scope="scope"
          effect="dark"
          placement="top"
          :content="scope.row.url"
        >
          <span>{{ scope.row.path }}</span>
        </el-tooltip>
      </el-table-column>

      <el-table-column prop="occurrenceTimeStr" label="调用时间" width="200">
        <div slot-scope="scope">
          {{ scope.row.occurrenceTimeStr }}
          <span style="color: #9b9b9b"> ({{ scope.row.elapsedTime }}ms) </span>
        </div>
      </el-table-column>

      <el-table-column prop="status" label="响应码" width="100" />

      <el-table-column label="来源" align="center">
        <el-table-column prop="className" label="引用">
          <span slot-scope="scope">
            {{ handleReferenceName(scope.row) }}
          </span>
        </el-table-column>
        <el-table-column prop="fromUrl" label="路径" width="180">
          <span slot-scope="scope">
            <span>{{ scope.row.fromMethod }}</span> {{ scope.row.fromUrl }}
          </span>
        </el-table-column>
        <el-table-column prop="caller" label="调用者" width="120" />
      </el-table-column>

      <el-table-column
        label="操作"
        show-overflow-tooltip
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="lookrequest(scope.row)">
            查看请求
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="isdialog" width="40%" append-to-body>
      <thirdlog-detail :log="looking" />
    </el-dialog>
  </base-query>
</template>

<script>
import BaseQuery from '@/components/BaseQuery.vue'
import apiRequest from './api.request'
import ThirdlogDetail from './ThirdlogDetail.vue'

export default {
  components: {
    BaseQuery,
    ThirdlogDetail,
  },

  mixins: [apiRequest],

  data() {
    return {
      optionloading: false,
      isloading: false,

      datasources: null,

      allpaths: {},
      ruleForm: {
        btm: '',
        etm: '',
        dataSource: '',
        path: '',
        caller: '',
        requestBody: '',
        responseBody: '',
        elapsedTime: '',
        fromPath: '',
        className: '',
        size: 50,
      },

      data: [],

      looking: null,
      isdialog: false,
    }
  },

  computed: {
    paths() {
      return this.allpaths[this.ruleForm.dataSource] || []
    },
  },

  watch: {
    'ruleForm.dataSource': {
      handler() {
        this.ruleForm.path = ''
      },
      immediate: true,
    },
  },

  methods: {
    handleReferenceName(row) {
      const { className, description } = row

      if (className) {
        if (typeof description === 'string') {
          const index = description.indexOf('#')
          if (index !== -1) {
            return className + description.substring(index)
          }
        }
      }
      return className
    },

    async loaddatasource0() {
      if (this.datasources !== null) {
        return
      }

      this.optionloading = true
      try {
        this.datasources = (await this.loaddatasource()) || []
      } finally {
        this.optionloading = false
      }
    },

    async loadpath() {
      if (this.allpaths[this.ruleForm.dataSource]) {
        return
      }
      this.optionloading = true
      try {
        const resp = await this.$api.get(
          `/schedules/apicallogs/thirdlogs/allpath`,
          {
            params: {
              datasource: this.ruleForm.dataSource,
            },
          }
        )

        if (resp.data.status === 1) {
          const data = resp.data.content || []
          const content = data.map(k => k.split('/')).filter(k => k)

          let ismatched = true

          while (ismatched && content.length > 1) {
            for (let i = 1; i < content.length; i++) {
              if (content[i - 1][0] !== content[i][0]) {
                ismatched = false
                break
              }
            }

            if (ismatched) {
              for (let i = 0; i < content.length; i++) {
                content[i].shift()
              }
            }
          }

          this.$set(
            this.allpaths,
            this.ruleForm.dataSource,
            content
              .map(chunks => chunks.join('/'))
              .map((k, i) => ({
                value: data[i],
                label: k,
              }))
          )
        }
      } finally {
        this.optionloading = false
      }
    },

    async onsearch() {
      this.isloading = true
      try {
        const resp = await this.$api.post(
          `/schedules/apicallogs/thirdlogs`,
          this.ruleForm
        )

        if (resp.data.status === 1) {
          const content = resp.data.content || {}
          this.data = content.list || []
          this.$emit('total', content.total)
        }
      } finally {
        this.isloading = false
      }
    },

    async lookrequest(row) {
      if (!row.looked) {
        this.isloading = true
        try {
          const resp = await this.loadrequest(row.index, row.id)
          if (resp.data.status === 1) {
            Object.entries(resp.data.content || {}).forEach(([k, v]) =>
              this.$set(row, k, v)
            )
            this.$set(row, 'looked', true)
          } else {
            this.$message.error(resp.data.message || '查看请求错误')
          }
        } finally {
          this.isloading = false
        }
      }

      this.looking = row
      this.isdialog = true
    },
  },
}
</script>

<style lang="scss" scoped>
.thirdlogs-query {
  ::v-deep .el-table thead.is-group th.el-table__cell {
    background: none;
  }

  ::v-deep .el-row .el-col:nth-last-of-type(1) {
    margin-right: 0;
  }

  ::v-deep .el-col {
    margin-right: 20px;
  }

  ::v-deep .refPagination input {
    width: 100px !important;
  }

  ::v-deep .el-table__expand-icon {
    visibility: hidden !important;
  }

  ::v-deep .el-table__expanded-cell {
    text-align: center !important;
    color: #3bafda;
  }

  ::v-deep .el-table th,
  .el-table tr {
    height: 30px;
  }

  ::v-deep .el-table th {
    height: 30px;
    padding: 0;
  }

  ::v-deep .el-scrollbar__view .el-select-dropdown__list li:nth-of-type(1) {
    color: #409eff;
    font-weight: 700;
  }

  ::v-deep .el-table .warning-row {
    background: rgba(241, 245, 247, 1) !important;
  }

  .serachBtn {
    padding: 9px 35px;
    color: #fff;
    background-color: rgba(4, 153, 255, 1);
    margin-bottom: 10px;
    border: 1px solid #3bafda;
  }

  .contentLeft {
    float: left;
    width: 90%;
  }

  .contenRight {
    position: absolute;
    right: 20px;
    bottom: 5px;
  }

  label:nth-of-type(2) {
    width: 10px !important;
  }

  .buttonTop {
    margin-bottom: 20px;

    .clickColor {
      background-color: #fff;
      padding: 9px 15px;
      margin-right: 10px;
    }

    .teshunormal {
      color: #3bafda;
      border: 1px solid #3bafda;
      width: 80px;
      cursor: pointer;
      background: #fff;
      text-align: center;
      margin-right: 20px;
    }
  }

  ::v-deep .el-table__empty-text {
    width: 100%;
  }
}
</style>
